import { useState } from "react";
import { useNavigate } from "react-router-dom";

const GOLD = "#c8956c";
const DARK = "#1c1712";

// Owner credentials — in production move to backend
const OWNER_ACCOUNTS = {
  "eva.mici":     { password: "vilaevaowner",   name: "Eva Mici",      property: "Vila Eva" },
  "anja.doksani": { password: "dahlilaowner",   name: "Anja Doksani",  property: "Dahlila's Home" },
};

export default function OwnerLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    setTimeout(() => {
      const u = username.trim().toLowerCase();
      const account = OWNER_ACCOUNTS[u];
      if (!account || account.password !== password) {
        setError("Incorrect username or password.");
        setPassword("");
        setLoading(false);
        return;
      }
      localStorage.setItem("ownerToken", "owner_" + Date.now());
      localStorage.setItem("ownerUser", JSON.stringify({ username: u, name: account.name, property: account.property }));
      navigate("/owner/dashboard");
    }, 600);
  }

  return (
    <div style={{ minHeight: "100vh", background: DARK, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", position: "relative", overflow: "hidden" }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500&family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      {/* Background glow */}
      <div style={{ position: "absolute", inset: 0, background: "radial-gradient(ellipse at 30% 50%, rgba(200,149,108,0.12) 0%, transparent 60%), radial-gradient(ellipse at 70% 20%, rgba(200,149,108,0.07) 0%, transparent 50%)", pointerEvents: "none" }} />

      <div style={{ position: "relative", width: "min(92vw, 400px)", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(200,149,108,0.2)", borderRadius: 22, padding: "36px 32px", backdropFilter: "blur(20px)" }}>
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", color: GOLD, opacity: 0.8, marginBottom: 8 }}>Booking Albania</div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 300, color: "#fff", letterSpacing: ".02em" }}>Owner Portal</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 5 }}>Track your property performance</div>
        </div>

        {/* Error */}
        {error && (
          <div style={{ background: "rgba(231,76,60,0.15)", border: "1px solid rgba(231,76,60,0.3)", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#ff8a80", marginBottom: 14 }}>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "rgba(255,255,255,0.35)", marginBottom: 6 }}>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="e.g. eva.mici"
              required
              style={{ width: "100%", background: "rgba(255,255,255,0.06)", border: "1.5px solid rgba(200,149,108,0.2)", borderRadius: 12, padding: "11px 14px", fontSize: 14, color: "#fff", fontFamily: "'DM Sans', sans-serif", outline: "none" }}
              onFocus={e => e.target.style.borderColor = GOLD}
              onBlur={e => e.target.style.borderColor = "rgba(200,149,108,0.2)"}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "rgba(255,255,255,0.35)", marginBottom: 6 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{ width: "100%", background: "rgba(255,255,255,0.06)", border: "1.5px solid rgba(200,149,108,0.2)", borderRadius: 12, padding: "11px 14px", fontSize: 14, color: "#fff", fontFamily: "'DM Sans', sans-serif", outline: "none" }}
              onFocus={e => e.target.style.borderColor = GOLD}
              onBlur={e => e.target.style.borderColor = "rgba(200,149,108,0.2)"}
            />
          </div>
          <button type="submit" disabled={loading} style={{ width: "100%", padding: 13, background: loading ? "rgba(200,149,108,0.5)" : GOLD, color: "#fff", border: "none", borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontFamily: "'DM Sans', sans-serif", letterSpacing: ".02em", transition: "all .25s" }}>
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <p style={{ textAlign: "center", fontSize: 11, color: "rgba(255,255,255,0.2)", marginTop: 18 }}>
          Admin? <a href="/admin" style={{ color: GOLD, textDecoration: "none" }}>Go to Admin Panel</a>
        </p>
      </div>

      <style>{`* { box-sizing: border-box; } ::placeholder { color: rgba(255,255,255,0.2) !important; }`}</style>
    </div>
  );
}
